import {API} from './api'
import {METHOD, request} from '@/utils/request'

/**
 * 事项管理左侧事项列表---查询所有事项（按机构排序）
 * @param {*} params 
 * @returns 
 */
export async function getAllEventsByOrg(params) {
    return request(API+'/item/getListOrderByOrg',
       METHOD.GET,
        params
    )
}

/**
 * 新增事项功能
 * @param {*} data 
 * @returns 
 */
export function save(data) {
    return request(API+'/item/insert', 
        METHOD.POST,
        data
    )
}

/**
 * 新增事项之后调用的接口，后台需要更新
 * @param {*} data 
 * @returns 
 */
 export function serveUpdate(params) {
    return request(API+'/leavingschool/graduationStudentItem/initStudentItem',
       METHOD.GET,
        params
    )
}

/**
 * 更新事项信息 
 * TODO 存在问题
 * @param {*} data 
 * @returns 
 */
export function update(data) {
    return request(API+'/item/update', 
        METHOD.POST,
        data
    )
}

/**
 * 删除事项信息
 * @param {*} id 
 * @returns 
 */
export function del(id) {
    return request(API+'/item/delete', 
        METHOD.DELETE,
        undefined,
        {params:{id}}
    )
}

/**
 * 查询角色事项列表及选中状态
 * @param {*} params 
 * @returns 
 */
export function getListAndCheck(params) {
    return request(API+'/item/getListAndCheck',
       METHOD.GET,
        params
    )
}


/**
 * 事项列表
 * @returns 
 */
export function listItem() {
    return request(API+'/item/getItemDic',
       METHOD.GET
    )
}